export default "__VITE_ASSET__347ed931__"